var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"KnFieldSelect contentModule",class:_vm.elmClasses,attrs:{"name":"KnFieldSelect"}},[_c('div',{staticClass:"KnFieldSelect__inner contentModule__inner"},[_vm._v(" KnFieldSelect "),_c('BaseSelect',{attrs:{"value":'',"label":'Choose ...',"options":_vm.field._options},on:{"change":_vm.onChange,"input":_vm.onInput}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }